import { render, staticRenderFns } from "./classMien.vue?vue&type=template&id=8f6b0f74&"
import script from "./classMien.vue?vue&type=script&lang=js&"
export * from "./classMien.vue?vue&type=script&lang=js&"
import style0 from "./classMien.vue?vue&type=style&index=0&id=8f6b0f74&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports